function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useState, useEffect } from 'react';
import feathers from '@cryptosheets/feathers-client';
var client = feathers('localStorage', 'socket');
export default function Linkify(_ref) {
  var {
    text
  } = _ref;
  var [src, setSrc] = useState('');
  useEffect(() => {
    function getSrc() {
      return _getSrc.apply(this, arguments);
    }

    function _getSrc() {
      _getSrc = _asyncToGenerator(function* () {
        var {
          data
        } = yield client.service('post-tags').find({
          query: {
            text
          }
        });
        var [tag] = data;

        if (tag) {
          setSrc(tag.src);
        }
      });
      return _getSrc.apply(this, arguments);
    }

    getSrc();
  }, [text]);
  return /*#__PURE__*/React.createElement("a", {
    href: src,
    target: "_blank",
    rel: "noreferrer"
  }, text);
}